import { useEffect } from "react";
import { useNavigate } from "@tanstack/react-router";
import { api } from "@/lib/api/client";
import { useAuthStore } from "@/lib/stores/authStore";
import { showToast } from "@/lib/utils/toast";

export function useTokenExpirationHandler() {
  const navigate = useNavigate();

  useEffect(() => {
    api.setTokenExpiredCallback(() => {
      const authStore = useAuthStore.getState();

      authStore.logout();

      showToast.error("Your session has expired. Please login again.");
      navigate({ to: "/auth/login" });

      console.log(
        "[TokenExpiration] User session expired - redirected to login"
      );
    });

    return () => {
      api.setTokenExpiredCallback(null);
    };
  }, [navigate]);
}
